<template>
  <div>
    <ed-campanha :intTipoServicoId="1411"  :key="$root.$session.versao"/>
  </div>
</template>

<script>
import EdCampanha from "@/components/campanha/editar";

export default {
  name: "pageCadastroEmpresa",
  props: {},
  components: {EdCampanha },
  mounted() {},
  created() {},
  data() {
    return {
    };
  },
  methods: {
  
  },
};
</script>